import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "px-6 pb-4" }
const _hoisted_2 = {
  key: 1,
  class: "text-center text-grey pa-6"
}
const _hoisted_3 = {
  key: 1,
  class: "d-flex justify-center align-center text-center",
  style: {"height":"100px","position":"relative"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_vue_loading = _resolveComponent("vue-loading")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "mx-auto overflow-hidden w-100",
    "max-width": "500"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex flex-column align-center text-center px-6 pt-6 pb-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            class: "text-orange-lighten-2 mb-2",
            size: "72px"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" mdi-alert-circle-outline ", -1)
            ]))]),
            _: 1
          }),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-h6 font-weight-bold" }, " 未確認の請求書があります ", -1))
        ]),
        _: 1
      }),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "px-6 pb-2" }, [
        _createElementVNode("div", {
          class: "text-grey-darken-1",
          style: {"font-size":"9px","line-height":"1.6","font-weight":"normal","text-align":"left","word-break":"break-all","display":"block"}
        }, [
          _createTextVNode(" 請求書のご確認をお願いいたします。"),
          _createElementVNode("br"),
          _createTextVNode(" 内容をご確認いただくまで、このお知らせが繰り返し表示されます。 ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.invoices.length > 0)
                ? (_openBlock(), _createBlock(_component_v_list, {
                    key: 0,
                    class: "pa-0",
                    "bg-color": "transparent"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoices, (i, index) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: index,
                          onClick: ($event: any) => (_ctx.toDetail(i)),
                          class: "px-0",
                          "min-height": "64px"
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_v_avatar, {
                              size: "40",
                              class: "me-3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_img, {
                                  src: i.imageUrl
                                }, null, 8, ["src"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          append: _withCtx(() => [
                            _createVNode(_component_v_badge, {
                              color: "red",
                              "offset-x": "4",
                              "offset-y": "0",
                              inline: ""
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, {
                              class: "text-body-2",
                              innerHTML: i.text
                            }, null, 8, ["innerHTML"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, " 未確認の請求書はありません。 ")),
              _createVNode(_component_v_card_actions, { class: "d-flex justify-center pt-6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    color: "pink-lighten-2",
                    class: "text-white",
                    variant: "flat",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode(" 閉じる ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_vue_loading, {
                loader: "bars",
                active: _ctx.isLoading,
                "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isLoading) = $event)),
                type: "grid",
                color: "#EE6090",
                width: 50,
                height: 50,
                "is-full-page": false
              }, null, 8, ["active"])
            ]))
      ])
    ]),
    _: 1
  }))
}